/* eslint-disable prettier/prettier */

import { Button, Input, Text } from '@grupoboticario/flora-react';
import { InputForm, InputTextAreaForm } from 'components/InputForm';
import { useForm, useWatch } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { FiSearch } from 'react-icons/fi';
import {  useEffect, useState } from 'react';
import { Popover } from 'components/Popover';
import { Form, Container, Footer } from './styles';
import { schema } from './schema';


export function Test() {
  const [isOpen, setIsOpen] = useState(false);
  const [search, setSearch] = useState('');
  const [inputTeste, setInputTeste] = useState('teste')

  const { control, handleSubmit } = useForm({
    resolver: yupResolver(schema),
  });

  const watchFields = useWatch({
    control,
    name: ['data'],
  });

  useEffect(()=>{
    console.log(watchFields)
  },[watchFields])

  function onSubmit(values: any) {
    console.log(values);
  }
  return (
    <Container>
      <Text as="h1">Sinistro</Text>

      <Input id="teste" label="teste" type="text" defaultValue={inputTeste} value={inputTeste} onChange={(e) => setInputTeste(e.target.value)} />

      <Form onSubmit={handleSubmit(onSubmit)}>

        <InputForm label="Nome" id="1" control={control} name="firstName" />

        <InputForm
          label="Sobrenome"
          id="2"
          control={control}
          name="lastName"
        />
        <InputForm
          label="Teste máscara"
          id="4"
          control={control}
          name="mascara"
          placeholder="R$ 000,00"
          mask={{
                type: 'number',
                style: 'currency',
              }}
        />
        <InputForm
          label="Teste data"
          id="5"
          control={control}
          type="text"
          mask="xx/xx/xx"
          name="data"
          placeholder="dd/mm/aa"
        />
        <InputTextAreaForm
          label="Descrição da ocorrência:"
          id="3"
          control={control}
          name="occurrenceDescription"
        />

        <div style={{
            justifyContent: 'center',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 30
          }}
        >
          <Popover
            visible={isOpen}
            position="left"
            content={(
              <Input
                value={search}
                onChange={({target}) => setSearch(target.value)}
                autoFocus
                className="teste"
                onBlur={() => setIsOpen(false)}
                label="Teset"
                id="234"
                placeholder=""
              />
          )}
          >
            <Button
              size="small"
              type="button"
              hierarchy="tertiary"
              onClick={() => setIsOpen(true)}
            >
              <FiSearch />
            </Button>
          </Popover>
        </div>
        <Footer>
          <Button>Salvar</Button>
        </Footer>
      </Form>
    </Container>
  );
}
